
(function(){
  var root = document.querySelector('.obaad');
  if (!root) return;

  /* ---- studio iframe autosize -------------------------------------------
     The studio reports its true content height. Apply it so the frame grows to
     fit and nothing ever scrolls inside the embed.

     maxHeight is cleared explicitly. An inline height does NOT beat a stylesheet
     max-height, so a leftover cap silently swallows this and hands the visitor a
     nested scrollbar, which is exactly the bug this replaced. */
  window.addEventListener('message', function(ev){
    if (!ev.data || ev.data.type !== 'oba:resize') return;
    var f = document.querySelector('.oa-frame iframe');
    var h = parseInt(ev.data.height, 10);
    if (!f || !(h > 400)) return;
    if (h > 12000) h = 12000;               /* runaway guard */
    f.style.maxHeight = 'none';
    /* A 1,500px jump should not animate. Only ease small settling changes. */
    var current = parseInt(f.style.height, 10) || f.getBoundingClientRect().height;
    f.style.transition = Math.abs(h - current) > 260 ? 'none' : 'height .2s ease';
    f.style.height = h + 'px';
  });

  /* Hide the sticky bar while the studio is on screen so it cannot stack on
     top of the studio's own price bar inside the iframe. */
  /* Hide the sticky bar while the studio owns the screen, so it cannot stack on
     the studio's own price bar.

     Deliberately NOT IntersectionObserver with a ratio threshold. The frame is
     now taller than the viewport (2,257px desktop, 4,490px mobile), so its
     intersection ratio can never reach a 0.2 threshold and the bar would simply
     never hide. Measuring how much of the VIEWPORT the frame covers works at any
     frame height. */
  var bar = document.querySelector('.oa-sticky');
  var frame = document.querySelector('.oa-frame');
  if (bar && frame) {
    var pending = false;
    var sync = function(){
      pending = false;
      var r = frame.getBoundingClientRect();
      var vh = window.innerHeight;
      var overlap = Math.min(r.bottom, vh) - Math.max(r.top, 0);
      bar.style.visibility = overlap > vh * 0.5 ? 'hidden' : '';
    };
    var queue = function(){ if (!pending) { pending = true; requestAnimationFrame(sync); } };
    window.addEventListener('scroll', queue, {passive: true});
    window.addEventListener('resize', queue);
    sync();
  }

  /* ---- animation -------------------------------------------------------- */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function start(){
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return false;
    gsap.registerPlugin(ScrollTrigger);
    root.classList.add('js-anim');
    if (reduced) return true;

    var heroImg = document.querySelector('.oa-hero-bg img');
    if (heroImg) {
      gsap.to(heroImg, {
        yPercent: 12, ease: 'none',
        scrollTrigger: {trigger: '.oa-hero', start: 'top top', end: 'bottom top', scrub: true}
      });
    }

    /* The hero entrance is a CSS animation. Deliberately not touched here. */

    gsap.utils.toArray('[data-reveal]').forEach(function(el){
      gsap.fromTo(el, {opacity: 0, y: 34},
        {opacity: 1, y: 0, duration: .8, ease: 'power3.out',
         scrollTrigger: {trigger: el, start: 'top 86%', toggleActions: 'play none none none'}});
    });

    gsap.utils.toArray('[data-reveal-group]').forEach(function(group){
      gsap.fromTo(group.children, {opacity: 0, y: 30},
        {opacity: 1, y: 0, duration: .68, ease: 'power2.out', stagger: .1,
         scrollTrigger: {trigger: group, start: 'top 84%', toggleActions: 'play none none none'}});
    });

    gsap.utils.toArray('[data-parallax]').forEach(function(box){
      var im = box.querySelector('img');
      if (!im) return;
      gsap.fromTo(im, {yPercent: -6}, {yPercent: 6, ease: 'none',
        scrollTrigger: {trigger: box, start: 'top bottom', end: 'bottom top', scrub: true}});
    });

    /* Every tween above is fromTo, so GSAP has already written inline opacity on
       each target. The class is now redundant, and dropping it means a later JS
       failure cannot leave anything hidden behind a CSS rule. */
    root.classList.remove('js-anim');

    /* Images settle after layout, which moves every trigger point. */
    window.addEventListener('load', function(){ ScrollTrigger.refresh(); });

    /* Last line of defense. If anything is still invisible well after load,
       show it. An unanimated page beats an empty one. */
    setTimeout(function(){
      document.querySelectorAll('[data-reveal],[data-reveal-group]>*').forEach(function(el){
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && getComputedStyle(el).opacity === '0') {
          el.style.opacity = '1';
          el.style.transform = 'none';
        }
      });
    }, 6000);
    return true;
  }

  /* GSAP loads deferred. Depending on parse order it may or may not be ready at
     DOMContentLoaded, so poll briefly, then give up and leave the page visible. */
  if (!start()) {
    var tries = 0;
    var t = setInterval(function(){
      if (start() || ++tries > 60) clearInterval(t);
    }, 50);
  }
})();
